var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon",class:_vm.iconId},[_c('use',{attrs:{"xlink:href":`#${_vm.iconId}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }